import { AlertDialogDescription, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export const ResetConfirmation = () => {
  return (
    <AlertDialogHeader>
      <AlertDialogTitle>Êtes-vous absolument sûr ?</AlertDialogTitle>
      <AlertDialogDescription>
        Cette action ne peut pas être annulée. Cela supprimera définitivement toutes vos données,
        y compris les produits, les transactions, l'historique et les paramètres.
      </AlertDialogDescription>
    </AlertDialogHeader>
  );
};